import { useState } from 'react';
import { Button } from 'react-bootstrap';
import ReviewForm from '../ReviewForm';

export const ShowMore = ({ className = '' }) => {
  const [showReviewForm, setShowReviewForm] = useState(false);
  const handleClick = () => {
    setShowReviewForm(true);
  };
  return (
    <>
      <ReviewForm show={showReviewForm} setShow={setShowReviewForm} />

      <Button
        className={`px-5 pb-2 mr-3 mr-md-1 mr-xl-n3 ${className}`}
        type="button"
        onClick={handleClick}
      >
        Escribe una reseña
      </Button>
    </>
  );
};
